import React, { useEffect, useState, useRef } from 'react';
import { UserIcon, CreditCardIcon, UsersIcon, ChevronDownIcon } from 'lucide-react';
export const ProfileDropdown: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  return <div className="relative" ref={dropdownRef} data-id="element-207">
      <button onClick={() => setIsOpen(!isOpen)} className="flex items-center space-x-2" data-id="element-208">
        <div className="h-8 w-8 rounded-full bg-blue-600 flex items-center justify-center text-white font-medium" data-id="element-209">
          JD
        </div>
        <ChevronDownIcon className="h-4 w-4 text-gray-500" data-id="element-210" />
      </button>
      {isOpen && <div className="absolute right-0 mt-2 w-48 bg-white border border-gray-200 rounded-md shadow-lg z-10" data-id="element-211">
          <div className="py-1" data-id="element-212">
            <a href="#profile" className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100" data-id="element-213">
              <UserIcon className="mr-3 h-4 w-4" data-id="element-214" /> Profile
            </a>
            <a href="#billing" className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100" data-id="element-215">
              <CreditCardIcon className="mr-3 h-4 w-4" data-id="element-216" /> Billing
            </a>
            <a href="#users" className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100" data-id="element-217">
              <UsersIcon className="mr-3 h-4 w-4" data-id="element-218" /> Users
            </a>
          </div>
        </div>}
    </div>;
};